import React, { useState, useEffect } from 'react';
import HomeTopBar from './HomeTopBar';
import PossibleForYouChart from '../charts/ImageryPerceptions/PossibleForYouChart';
import EasyToDealWithChart from '../charts/ImageryPerceptions/EasyToDealWithChart';
import RespondsToWhatYouNeedChart from '../charts/ImageryPerceptions/RespondsToWhatYouNeedChart';
import FindsNewWaysToDoThingsChart from '../charts/ImageryPerceptions/FindsNewWaysToDoThingsChart';
import SupportsYourAspirationsChart from '../charts/ImageryPerceptions/SupportsYourAspirationsChart';
import LeaderInPersonalBankingChart from '../charts/ImageryPerceptions/LeaderInPersonalBankingChart';
import IsTrustWorthyChart from '../charts/ImageryPerceptions/IsTrustWorthyChart';
import UsesTechnologyChart from '../charts/ImageryPerceptions/UsesTechnologyChart';
import LeadingOrganisationChart from '../charts/ImageryPerceptions/LeadingOrganisationChart';
import ProductsAndOpportunitiesChart from '../charts/ImageryPerceptions/ProductsAndOpportunitiesChart';
import DrivesSAGrowthChart from '../charts/ImageryPerceptions/DrivesSAGrowthChart';
import ValuablePartnerChart from '../charts/ImageryPerceptions/ValuablePartnerChart';
import IsConfidentChart from '../charts/ImageryPerceptions/IsConfidentChart';
import MotivatesYouToGrowMoreChart from '../charts/ImageryPerceptions/MotivatesYouToGrowMoreChart'
import UnderstandsYouChart from '../charts/ImageryPerceptions/UnderstandsYouChart'
import axios from 'axios';
import { provinces, local_market, province_market_map, segments } from '../constants';
import ImageryPerceptionsPPTX from '../powerpoint/ImageryPerceptionsPPTX';

const ImageryPerceptions = ({ heading, possible_for_you, easy_to_deal_with, responds_to_needs, new_ways, aspirations, trustworthy, uses_technology, leader_personal_banking, leading_organisation, products_and_opportunities, valuable_partner, drives_sa_growth, confident, motivates_to_grow, understands_you }) => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState(''); 
  const [localMarkets, setLocalMarkets] = useState([]);
  const [possibleForYouData, setPossibleForYouData] = useState([]);
  const [easyToDealWithData, setEasyToDealWithData] = useState([]);
  const [respondsToWhatYouNeedData, setRespondsToWhatYouNeedData] = useState([]);
  const [newWaysToDoThingsData, setNewWaysToDoThingsData] = useState([]);
  const [supportsYourAspirationsData, setSupportsYourAspirationsData] = useState([]);
  const [isTrustWorthyData, setIsTrustWorthyData] = useState([]);
  const [usesTechnologyData, setUsesTechnologyData] = useState([]);
  const [leaderInPersonalBankingData, setLeaderInPersonalBankingData] = useState([]);
  const [leadingOrganisationData, setLeadingOrganisationData] = useState([]);
  const [productsAndOpportunitiesData, setProductsAndOpportunitiesData] = useState([]);
  const [valuablePartnerData, setValuablePartnerData] = useState([]);
  const [drivesSAGrowthData, setDrivesSAGrowthData] = useState([]);
  const [isConfidentData, setIsConfidentData] = useState([]);
  const [motivatesYouToGrowMoreData, setMotivatesYouToGrowMoreData] = useState([]);
  const [understandsYouData, setUnderstandsYouData] = useState([]);
    

  const handleProvinceChange = (e) => {
    const selectedProvince = e.target.value;
    setSelectedProvince(selectedProvince);

    if (selectedProvince && province_market_map[selectedProvince]) {
      setLocalMarkets(province_market_map[selectedProvince].local_markets);
    } else {
      setLocalMarkets([]);
    }
    setSelectedLocalMarket('');
  };

  const getProvinceValue = () => (selectedProvince ? provinces[selectedProvince] : '');
  const getLocalMarketValue = () => (selectedLocalMarket ? local_market[selectedLocalMarket] : '');  

  const fetchImageryPerceptionsData = async (preferenceType, setData) => {
    try {
      const provinceValue = getProvinceValue();
      const localMarketValue = getLocalMarketValue();

      const response = await axios.get(`https://outlook.plus94research.co.za/api/imagery-perceptions/${preferenceType}/`, {
        params: {
          province: provinceValue,
          local_market: localMarketValue,         
        },
      });
      setData(response.data);
    } catch (error) {
      console.error(`Error fetching data for ${preferenceType}:`, error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchImageryPerceptionsData('possible_for_you', setPossibleForYouData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('easy_to_deal_with', setEasyToDealWithData);
  }, [selectedProvince, selectedLocalMarket]);
 

  useEffect(() => {
    fetchImageryPerceptionsData('responds_to_what_you_need', setRespondsToWhatYouNeedData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('new_ways_to_do_things', setNewWaysToDoThingsData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('supports_your_aspirations', setSupportsYourAspirationsData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('is_trustworthy', setIsTrustWorthyData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('uses_technology', setUsesTechnologyData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('leader_in_personal_banking', setLeaderInPersonalBankingData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('is_a_leading_organisation', setLeadingOrganisationData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('offers_relevant_products', setProductsAndOpportunitiesData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('is_a_valuable_partner', setValuablePartnerData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('drives_sa_growth', setDrivesSAGrowthData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('is_confident', setIsConfidentData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('motivates_to_grow_more', setMotivatesYouToGrowMoreData);
  }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    fetchImageryPerceptionsData('understands_you', setUnderstandsYouData);
  }, [selectedProvince, selectedLocalMarket]);



  return (
    <div className='home'>
      <HomeTopBar />
      <div className='three-charts-heading-div'>
        <h2 className='heading'>{heading}</h2>
      </div>

      <div className='filter'>
        <label htmlFor="province-select">Province: </label>
        <select
          id="province-select"
          value={selectedProvince}
          onChange={handleProvinceChange}
        >
          <option value="">All</option>
          {Object.keys(provinces).map((province) => (
            <option key={province} value={province}>
              {province}
            </option>
          ))}
        </select>

        <label htmlFor="local-market-select">Local Market: </label>
        <select
          id="local-market-select"
          value={selectedLocalMarket}
          onChange={(e) => setSelectedLocalMarket(e.target.value)}
          disabled={!selectedProvince || localMarkets.length === 0}
        >
          <option value="">All</option>
          {localMarkets.map((market, index) => (
            <option key={index} value={market}>
              {market}
            </option>
          ))}
        </select>
  
      </div>

       <div>
        <ImageryPerceptionsPPTX
          selectedProvince={selectedProvince}
          selectedLocalMarket={selectedLocalMarket}
          possibleForYouData={possibleForYouData}         
          easyToDealWithData={easyToDealWithData}   
          respondsToWhatYouNeedData={respondsToWhatYouNeedData}  
          newWaysToDoThingsData={newWaysToDoThingsData} 
          supportsYourAspirationsData={supportsYourAspirationsData}
          isTrustWorthyData={isTrustWorthyData}
          usesTechnologyData={usesTechnologyData}
          leaderInPersonalBankingData={leaderInPersonalBankingData}
          leadingOrganisationData={leadingOrganisationData}
          productsAndOpportunitiesData={productsAndOpportunitiesData}
          valuablePartnerData={valuablePartnerData}
          drivesSAGrowthData={drivesSAGrowthData}
          isConfidentData={isConfidentData} 
          motivatesYouToGrowMoreData={motivatesYouToGrowMoreData}
          understandsYouData = {understandsYouData}
        />
      </div> 

      <div className='imagery-container'>

        <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{possible_for_you}</h2>
            <PossibleForYouChart data={possibleForYouData} />
          </div>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{easy_to_deal_with}</h2>
            <EasyToDealWithChart data={easyToDealWithData} />
          </div>
        </div>   

        <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{responds_to_needs}</h2>
            <RespondsToWhatYouNeedChart data={respondsToWhatYouNeedData} />
          </div>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{new_ways}</h2>
            <FindsNewWaysToDoThingsChart data={newWaysToDoThingsData} />
          </div>
        </div> 

        <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{aspirations}</h2>
            <SupportsYourAspirationsChart data={supportsYourAspirationsData} />
          </div>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{trustworthy}</h2>
            <IsTrustWorthyChart data={isTrustWorthyData} />
          </div>
        </div> 


        <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{uses_technology}</h2>
            <UsesTechnologyChart data={usesTechnologyData} />
          </div>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{leader_personal_banking}</h2>
            <LeaderInPersonalBankingChart data={leaderInPersonalBankingData} />
          </div>
        </div> 

        <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{leading_organisation}</h2>
            <LeadingOrganisationChart data={leadingOrganisationData} />
          </div>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{products_and_opportunities}</h2>
            <ProductsAndOpportunitiesChart data={productsAndOpportunitiesData} />
          </div>
        </div> 

        <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{valuable_partner}</h2>
            <ValuablePartnerChart data={valuablePartnerData} />
          </div>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{drives_sa_growth}</h2>
            <DrivesSAGrowthChart data={drivesSAGrowthData} />
          </div>
        </div> 

        <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{confident}</h2>
            <IsConfidentChart data={isConfidentData} />
          </div>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{motivates_to_grow}</h2>
            <MotivatesYouToGrowMoreChart data={motivatesYouToGrowMoreData} />
          </div>
        </div> 


         <div className='imagery-pair'>
          <div className='imagery-chart'>
            <h2 className='imagery-heading'>{understands_you}</h2>
            <UnderstandsYouChart data={understandsYouData} />
          </div>
        </div> 

      </div>
    </div>
  );
};

export default ImageryPerceptions;



